import { render } from "./a-tasks-table.vue?vue&type=template&id=2dfbf12e&scoped=true"
import script from "./a-tasks-table.vue?vue&type=script&lang=js"
export * from "./a-tasks-table.vue?vue&type=script&lang=js"

import "./a-tasks-table.vue?vue&type=style&index=0&id=2dfbf12e&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfbf12e"]])

export default __exports__